<template>
  <div class="login">
    <el-container>
      <el-header>资源开放平台后台管理系统</el-header>
      <el-main>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px" class="demo-ruleForm">
          <el-form-item prop="username">
            <el-input type="text" v-model.trim="ruleForm.username" placeholder="请输入用户名"  clearable maxlength="64">
              <template slot="prepend"><img class="user" src="../../assets/images/user.png" alt=""/></template>
            </el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input type="password" placeholder="请输入密码" v-model.trim="ruleForm.password" @keyup.enter.native="submitForm('ruleForm')" clearable maxlength="100">
              <template slot="prepend"> <img class="password" src="../../assets/images/password.png" alt=""/> </template>
            </el-input>
          </el-form-item>
          <el-form-item prop="verifyCode" v-if="false">
            <el-input class="verify" type="text" placeholder="请输入验证码"  @keyup.enter.native="submitForm('ruleForm')" clearable></el-input>
            <div class="verification-code" @click="reflushVerificationCode">
              <img :src="imageUrl">
            </div>
          </el-form-item>
          <div class="login-btn">
            <el-button type="primary" @click="submitForm('ruleForm')">登录</el-button>
          </div>
        </el-form>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import { Container, Header, Main, Input, Form, FormItem, Button} from 'element-ui'
import commonService from '@/service/commonService'
export default {
  data: function () {
    let checkName = (rule, value, cb) => {
      this.$store.commit('checkName', {rule, value, cb})
    }
    return {
      imageUrl: '/api/v1/auth/code/image?t=' + new Date().getTime(),
      ruleForm: {
        username: '',
        password: ''
        //        verifyCode:""
      },
      rules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      }
    }
  },
  components: {
    elContainer: Container,
    elHeader: Header,
    elMain: Main,
    elInput: Input,
    elForm: Form,
    elFormItem: FormItem,
    elButton: Button
  },
  name: 'login',
  async mounted () {
    await this.reflushVerificationCode()
  },
  methods: {
    async fetchUserInfo () {
      let userinfo = await commonService.fetchUserInfo()
      return userinfo
    },
    async reflushVerificationCode () {
      this.imageUrl = '/api/v1/auth/code/image?t=' + new Date().getTime()
    },
    submitForm (formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          this.$cookie.set('token', this.SysConstant.basicAuth)
          try {
            let data = await commonService.login(this.ruleForm)
            if (data) {
              this.$cookie.set(
                'token',
                data.token_type + ' ' + data.access_token,
                {
                  expires: '3600s'
                }
              )
              let userInfo = await this.fetchUserInfo()
              this.$store.commit('clearUserInfo')
              this.$store.commit('setUserInfo', userInfo)
              this.$router.push({name: 'adminlayout'})
            }
          } catch (e) {
            this.$message.error(e && e.msg)
          }
        } else {
          this.$message.error('登录失败')
          return false
        }
      })
    }
  }

}
</script>
<style scoped>

</style>
<style type="text/css">

  .login {
    height:100%;
    width:100%;
    position: absolute;
    background-image: url(../../assets/images/background.png);
    background-position: center;
  }

  .login .el-header{
    width:400px;
    height:200px;
    margin:5% auto 0;
    color: #ffffff;
    font-size:25px;
    text-align: center;
    line-height: 60px;
  }
  .login .el-container {
    postion:relative;
  }
  .login .el-main {
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -90px;
    margin-left: -200px;
    width: 400px;
    color: #333;
    line-height: 20px;
  }

  /*.login .el-input{*/
    /*width:90%;*/
    /*border-color:#16d0ff;*/
    /*background:#16d0ff;*/
  /*}*/
  .login .el-input__inner:focus{
    border-color:#16d0ff;
  }

  .login  .el-form-item.is-success .el-input__inner,
  .login .el-form-item.is-success .el-input__inner:focus,
  .login .el-form-item.is-success .el-textarea__inner,
  .login  .el-form-item.is-success .el-textarea__inner:focus {
    border-color: #16d0ff;
  }

  .login .el-input__inner{
    color:#fff;
    border-color:#16d0ff;
    background-color:rgba(22,208,255,0.2);
    /*opacity:.9;*/
  }
  .login .verify{
    width:50%;
  }
  .login .clear{
    clear:both;
  }
  .login .user, .login .password{
    width:40px;
    height:40px;
    position: absolute;
    top:0;
    right:0;
  }
  .login .password{
    top:0;
  }
  .login .autoLogin{
   color:#fff
  }
  .login .el-button{
    width:360px;
    background: #20a8d8;
    font-size:18px;
  }
  .login .login-btn{
      margin-top:20px;
  }

  .login .verification-code{
    vertical-align: top;
    display: inline-block;
  }

  .login .verification-code img{
    width: 120px;
    height: 40px;
    margin-left: 10px;
    background-color: #ffffff;
    border: solid 1px #e1e1e1;
    cursor: pointer;
  }

</style>



// WEBPACK FOOTER //
// src/pages/login/index.vue